export const API_URL = "https://api.s-dashboard.com";
